import type Fuse from "fuse.js";

export const FUSE_OPTIONS: Fuse.IFuseOptions<unknown> = {
  shouldSort: true,
  includeMatches: true,
  threshold: 0.5,
  location: 0,
  distance: 100,
  minMatchCharLength: 1,
};
